import styled from 'styled-components';
import { Icon } from '@btc-snxt/ui';

export const StyledSubscribeBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledNameText = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.blue};
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
`;

export const StyledIcon = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4.375rem;
  width: 4.375rem;
  margin: 1rem;
  border-radius: 3rem;
  background-color: rgba(0, 130, 184, 0.15);

  ${Icon} {
    height: 2rem;
    width: 2rem;
  }
`;

export const StyledPriceBlock = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledPrice = styled.div`
  display: flex;
  align-items: end;
  color: ${({ theme }) => theme.colors.black};
  font-size: 2.25rem;
  line-height: 2.125rem;
`;

export const StyledPriceText = styled.div`
  display: flex;
  align-items: end;
  color: ${({ theme }) => theme.colors.black};
  font-size: 0.75rem;
`;

export const StyledBillingText = styled.div`
  font-size: 1rem;
  margin: 1rem;
  margin-bottom: 0.5rem;
`;

export const StyledSwitchBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledYearlyText = styled.div`
  font-size: 1rem;
`;

export const StyledMonthlyText = styled.div`
  font-size: 1rem;
`;

export const StyledSlider = styled.div`
  width: 100%;
`;

export const StyledLabel = styled.div`
  font-size: 1rem;
  margin-top: 1rem;
`;
